import {action, makeAutoObservable} from 'mobx';

import {not} from '../conditionalUtils';

export class FlagManager {
  value = false;

  constructor(value?: boolean) {
    this.value = value ?? false;
    makeAutoObservable(
      this,
      {
        setValue: action,
      },
      {autoBind: true},
    );
  }

  get isFalse() {
    return not(this.value);
  }

  get isTrue() {
    return this.value;
  }

  setFalse() {
    this.setValue(false);
  }

  setTrue() {
    this.setValue(true);
  }

  setValue(value: boolean) {
    if (value !== this.value) {
      this.value = value;
    }
  }

  toggle() {
    this.value = not(this.value);
  }
}
